import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ExcerptPipe, IPublishedAnnouncement } from '@resident-nx/shared';
import { CardFooterWebComponent } from '../card-footer/card-footer.component';
import { LabelWebComponent } from '../../atoms/label/label.component';

@Component({
  standalone: true,
  selector: 'rs-web-announcements-card',
  templateUrl: './announcements-card.component.html',
  styleUrls: ['./announcements-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LabelWebComponent, CardFooterWebComponent, ExcerptPipe],
})
export class AnnouncementsCardWebComponent {
  @Input() item: IPublishedAnnouncement;
}
